import { defineMessages } from 'react-intl';

export default defineMessages({
  exteriorFormPlaceHolder: {
    id: 'designOptionFilters.exteriorPlaceHolder',
    description: 'exterior option place holder',
    defaultMessage: 'Search by exterior code or name',
  },
  interiorFormPlaceHolder: {
    id: 'designOptionFilters.interiorPlaceHolder',
    description: 'interior option place holder',
    defaultMessage: 'Search by interior code or name',
  },
  wheelFormPlaceHolder: {
    id: 'designOptionFilters.wheelPlaceHolder',
    description: 'wheel option place holder',
    defaultMessage: 'Search by wheel code or name',
  },
  trimFormPlaceHolder: {
    id: 'designOptionFilters.trimPlaceHolder',
    description: 'trim option place holder',
    defaultMessage: 'Search by trim code or name',
  },
  roofAndMirrorCapFormPlaceHolder: {
    id: 'designOptionFilters.roofAndMirrorCapsPlaceHolder',
    description: 'roof and mirror caps option place holder',
    defaultMessage: 'Search by roof and mirror caps code or name',
  },
  colorLinesFormPlaceHolder: {
    id: 'designOptionFilters.colorLinesPlaceHolder',
    description: 'color lines option place holder',
    defaultMessage: 'Search by color lines code or name',
  },
  exteriorFiltersHeader: {
    id: 'designOptionFilters.exteriorHeader',
    description: 'exterior header',
    defaultMessage: 'EXTERIOR',
  },
  interiorFiltersHeader: {
    id: 'designOptionFilters.interiorHeader',
    description: 'interior header',
    defaultMessage: 'INTERIOR',
  },
  trimFiltersHeader: {
    id: 'designOptionFilters.trimHeader',
    description: 'trim header',
    defaultMessage: 'TRIM',
  },
  wheelFiltersHeader: {
    id: 'designOptionFilters.wheelHeader',
    description: 'wheel header',
    defaultMessage: 'WHEELS',
  },
  roofAndMirrorCapsFiltersHeader: {
    id: 'designOptionFilters.roofAndMirrorCapsHeader',
    description: 'roof and mirror caps header',
    defaultMessage: 'ROOF AND MIRROR CAPS',
  },
  colorLinesFiltersHeader: {
    id: 'designOptionFilters.colorLinesHeader',
    description: 'color lines header',
    defaultMessage: 'COLOR LINES',
  },
  clearFiltersText: {
    id: 'designOptionFilters.clear',
    description: 'clear filters button',
    defaultMessage: 'Clear all filters',
  },
  linkSearchWithinGroup: {
    id: 'designOptionFilters.search',
    description: 'search within group',
    defaultMessage: 'Search within group',
  },
  linkFiltersWithinGroup: {
    id: 'designOptionFilters.filter',
    description: 'filter within group',
    defaultMessage: 'Filter within group',
  },
});
